import { CompanionError } from '../_internal/error/CompanionError';
/**
 * Convert File/Blob object to base64 string
 */
export function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            if (typeof reader.result !== 'string') {
                return reject(new CompanionError({
                    error: new Error('Invalid result from FileReader'),
                    code: 'FILEREADER_RESULT_INVALID',
                }));
            }
            const [meta, content] = reader.result.split(',');
            const [mimetype, encoding] = meta.split(';');
            resolve({
                raw: reader.result,
                content,
                mimetype,
                encoding,
            });
        };
        reader.onerror = (error) => {
            reject(error);
        };
    });
}
fileToBase64.ERR = {
    FILEREADER_RESULT_INVALID: 'FILEREADER_RESULT_INVALID',
};
